// eslint-disable-next-line @typescript-eslint/no-unused-vars
import React from 'react'
import { ApolloProvider } from '@apollo/client'
import { datadogRum, DefaultPrivacyLevel } from '@datadog/browser-rum';
import packageJson from './package.json'

import { client } from './src/apollo/client'
import FrameLayout from './src/components/FrameLayout/FrameLayout'

import './src/styles/global.scss'

const defaultPrivacyLevel = 'mask-user-input' as DefaultPrivacyLevel;

const configInitDataDog = {
  applicationId: process.env.DATADOG_ID_APLICATION || '',
  clientToken: process.env.DATADOG_CLIENT_TOKEN || '',
  site: 'datadoghq.com',
  service: packageJson?.name,
  env: process.env.DATADOG_ENV,
  trackInteractions: true,
  version: packageJson?.version,
  sessionSampleRate: 100,
  sessionReplaySampleRate: 20,
  defaultPrivacyLevel,
  trackResources: true,
  trackLongTasks: true,
  sessionExpirationDelay: 3 * 60 * 1000,
};

datadogRum.init(configInitDataDog);

export const wrapRootElement = ({ element }) => {
  if (typeof window !== 'undefined') window.onunload = () => true
  return <ApolloProvider client={client}>{element}</ApolloProvider>
}

export const wrapPageElement = ({ element, props }) => {
  const compactLayout = (() => {
    if (typeof window === 'undefined') return false
    const isWebView = window.navigator?.userAgent?.includes('WomAppWebView')
    const isIframe = window.top !== window.self
    return isWebView || isIframe
  })()

  if (compactLayout) return element
  return <FrameLayout {...props}>{element}</FrameLayout>
}
